import { RoleFragment } from '../gql'

export const defaultSeedRole = {
  archivedAt: null,
  base: true,
  purpose: '',
  domain: '',
  accountabilities: '',
  checklist: '',
  indicators: '',
  notes: '',
  singleMember: true,
  parentLink: false,
  colorHue: null,
}

// The link role a circle gets by default when it has none. Exported so callers
// name it once: an org may rename or replace its own link roles, so this is
// only ever used to pick which base role to CREATE — never to find the link
// roles a circle already has (that is `role.parentLink`, whatever the name).
export const leaderSeedRoleName = 'Leader'

export const getSeedRoles = (orgId: string): Omit<RoleFragment, 'id'>[] =>
  [
    { name: leaderSeedRoleName, parentLink: true, colorHue: 0 },
    { name: 'Représentant', parentLink: true, colorHue: 18 },
    { name: 'Secrétaire', colorHue: 283 },
    { name: 'Facilitateur', colorHue: 111 },
  ].map((partialRole) => ({
    ...defaultSeedRole,
    orgId,
    ...partialRole,
  }))
